<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="Chapter101">
<p class="centerImage"><img alt="images" id="img7" src="images/img7.jpg"/></p>
<p class="caption">Flying Officer George Cook (far right) joined 49 Squadron at Scampton, Lincolnshire in 1941 as a Hampden wireless operator and completed thirty-two operations including the first two thousand-bomber raids. Next to George is his pilot Sgt Latty <em class="italic">Cook</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// HeroesAll_Chapter101.vue?49fc4539